import { graphql } from "@opensea/graphql"
import { TeamModuleCarouselFragment } from "./components/TeamModuleCarousel/TeamModuleCarousel.fragment"

export const TeamModuleFragment = graphql(
  `
    fragment TeamModule on CollectionTeamModule {
      title
      description
      ...TeamModuleCarousel
    }
  `,
  [TeamModuleCarouselFragment],
)
